export const FONT_BASE_URL =
  "https://res.cloudinary.com/busha-inc/raw/upload/v1651833681/fonts/Roobert";

export const API_URL = process.env.REACT_APP_API_URL;

export const BUSHA_AUTH_API_URL = process.env.REACT_APP_BUSHA_AUTH_URL;

export const BUSHA_GATEWAY_URL = process.env.REACT_APP_PLATFORM_URL;

export const PLATFORM_URL = process.env.REACT_APP_PLATFORM_URL;
export const APP_COMMERCE_URL = process.env.REACT_APP_COMMERCE_URL;

export const RECAPTCHA_SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY;

export const BUSHA_LOGO =
  "https://res.cloudinary.com/busha-inc/image/upload/v1658597995/pug/pay/busha-logo.png";

export const COIN_IMG_BASE_URL =
  "https://res.cloudinary.com/busha-inc/image/upload/v1628857343/App/Currencies";

export const SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN;

export const WEBSOCKET_BASE_URL = process.env.REACT_APP_WEBSOCKET_BASE_URL;

export const BUSHA_URL = process.env.REACT_APP_BUSHA_URL;

export const BUSHA_TERMS_URL = "https://www.busha.co/busha-commerce-terms";

export const BUSHA_PRIVACY_URL =
  "https://www.busha.co/busha-commerce-privacy-policy";

export const INITIALIZED_STATUS = "INITIALIZED";

export const CANCELLED_STATUS = "CANCELLED";

export const COMPLETED_STATUS = "COMPLETED";

export const PAYMENT_LINK = "payment-link";
export const PAYMENT_REQUEST = "payment-request";

export const AUTH_APP_URL =
  process.env.REACT_APP_AUTH_APP_URL ?? "https://accounts.busha.co";

/** Related application IDs from manifest (production + dev) for getInstalledRelatedApps check */
export const BUSHA_RELATED_APP_IDS = [
  "co.busha.android",
  "co.busha.apple",
  "co.busha.android.development",
  "co.busha.boro.development",
];

export const FIREBASE_COIN_IMG_BASE_URL =
  "https://firebasestorage.googleapis.com/v0/b/busha-mobile/o/assets%2F";

export const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;

export const APP_ENV = process.env.REACT_APP_ENV as "development" | "production" | "staging" || "development";